import React, { forwardRef } from 'react';
import { excludeChildrenByType, findChildByType } from '@fiverr-private/ui_utils';
import { Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import type { Types } from '@fiverr-private/theme';
import { DrawerChildrenProps } from '../types';
import { DRAWER_CLOSE_BTN_ID } from '../constants';

const DrawerHeader = forwardRef<HTMLElement, DrawerChildrenProps & Types.GlobalStylingProps>(
  ({ children, ...restProps }, ref) => {
    const closeButton = findChildByType(children, DRAWER_CLOSE_BTN_ID);
    const restOfChildren = excludeChildrenByType(children, DRAWER_CLOSE_BTN_ID);

    return (
      <Stack
        as="header"
        alignItems="center"
        justifyContent="spaceBetween"
        borderBottomWidth="sm"
        borderStyle="solid"
        borderColor="border"
        paddingX={{ default: '6', sm: '8' }}
        paddingTop={{ default: '4', sm: '6' }}
        paddingBottom="4"
        ref={ref}
        {...restProps}
      >
        <Heading as="h4" flex="1">
          {restOfChildren}
        </Heading>
        {closeButton}
      </Stack>
    );
  }
);

DrawerHeader.displayName = 'DrawerHeader';

export default DrawerHeader;
